import { AxiosInstance } from 'axios';

import { initializeHttpClient } from '../httpClient.config';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type TFetcher = (url: string) => Promise<any>;

let httpClient: AxiosInstance;
let fetcher: TFetcher;

/**
 * Hook to initialize the current httpClient (with features).
 * Note that this hook does not use useState to store the clients
 * but rather rely on a static instance to ensure the client and fetchers
 * are initialized immediately when called (and does not return undefined instance).
 *
 * @returns the current HTTP Client (axios) instance
 */
export const useHttpClient = () => {
  if (!httpClient) {
    httpClient = initializeHttpClient();
    fetcher = (url: string) => httpClient.get(url).then((res) => res.data);
  }

  return {
    httpClient,
    fetcher,
  };
};
